export default __webpack_public_path__ + "static/media/ico_checkList.4f3e818b.svg";